import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { MenuStore } from '../../../menus/service/menu.store';
import { OnyxEvent } from '../../models/event';
import { EventStore } from '../../service/event.store';
import { ReservationCompareStore } from '../../service/reservation-compare-store';
import { AuthenticationStore } from '../../../permission/services/authentication.store';
import { EventUtils } from 'app/event/utils/event-utils';
import { Party } from 'app/event/models/party';

@Component({
  selector: 'pioneer-rsvp',
  templateUrl: './rsvp-page.component.html'
})
export class RsvpComponent implements OnInit {

  public onyxEvent: OnyxEvent;

  public vendor: Party;

  disableCompareButton$: Observable<boolean>;
  showReservationCompareSummary$: Observable<boolean>;
  areRsvpsPresent$: Observable<boolean>;

  isInDetail: boolean;

  public eventLink: string;

  constructor(
    private eventStore: EventStore,
    private reservationCompareStore: ReservationCompareStore,
    private menuStore: MenuStore,
    private router: Router,
    private authStore: AuthenticationStore
  ) { }

  ngOnInit(): void {
    this.eventStore.selectedEvent.subscribe(event => this.onyxEvent = event);
    if (this.onyxEvent) {
      this.menuStore.setPageHeader(EventUtils.getEventName(this.onyxEvent, this.authStore.isAgencyUser()),
        this.onyxEvent.eventProperty.subscriber);

      this.vendor = this.onyxEvent.eventProperty;
    }

    this.disableCompareButton$ = this.reservationCompareStore.isCompareListEmpty();
    this.showReservationCompareSummary$ = this.reservationCompareStore.getShowReservationCompareSummary();
    this.areRsvpsPresent$ = this.reservationCompareStore.areRsvpsPresent();

    this.checkDetailPath(this.router.url);

    if (this.isMultiVendor()) {
      this.eventLink = this.onyxEvent.eventId + '';
    } else {
      this.eventLink = this.onyxEvent.eventId + '/' + this.onyxEvent.eventProperty.eventPartyId;
    }
  }

  navigateTo(path: string) {
    this.checkDetailPath(path);
    this.router.navigate([path]);
  }

  checkDetailPath(path: string) {
    this.isInDetail = path.indexOf('/detail') !== -1;
  }

  isMultiVendor() {
    return this.authStore.hasPermission('MultiVendor');
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/rsvp/rsvp-page/rsvp-page.component.ts